import patient from './modules/patient';
import user from './modules/user';
import setting from './modules/setting';
import dashboard from './modules/dashboard';
import medicine from './modules/medicine';
import certificate from './modules/certificate';
import reminder from './modules/reminder';
import fcfs from './modules/fcfs';
import appointment from './modules/appointment';
import doctor from './modules/doctor';

/**
 * Nested Routes
 * @type {*[]}
 */
const nestedRoutes = [].concat(
  dashboard,
  setting,
  patient,
  medicine,
  certificate,
  user,
  reminder,
  fcfs,
  appointment,
  doctor
);

export default nestedRoutes;



// WEBPACK FOOTER //
// ./src/router/nested-routes.js